import { IBaseGuidDTO, BaseGuidDTO } from "./dto.base";

export interface IMunicipioDTO extends IBaseGuidDTO {

    UF: string;
    Nome: string;
    Codigo: string;

}

export class MunicipioDTO extends BaseGuidDTO implements IMunicipioDTO {

    UF: string;
    Nome: string;
    Codigo: string;

    constructor(data: any = {}) {
        super(data);
        this.Codigo = data.Codigo;
        this.Nome = data.Nome;
        this.UF = data.UF;
    }
}